import { jsxs as t, jsx as r, Fragment as d } from "react/jsx-runtime";
import { Container as f, Title as h, Value as p } from "./styles.js";
import { Link as n } from "../Link/Link.js";
const u = ({
  title: l,
  children: a,
  href: i,
  clickable: s = !1,
  alignRight: o = !1,
  percent: c = !1,
  className: m
}) => /* @__PURE__ */ t(f, { $alignRight: o, className: m, children: [
  /* @__PURE__ */ r(h, { children: l }),
  /* @__PURE__ */ r(p, { children: (() => {
    const e = /* @__PURE__ */ t(d, { children: [
      a,
      c && "%"
    ] });
    return i ? /* @__PURE__ */ r(n, { href: i, children: e }) : s ? /* @__PURE__ */ r(n, { children: e }) : e;
  })() })
] });
u.displayName = "Stats";
export {
  u as Stats
};
//# sourceMappingURL=Stats.js.map
